import { combineReducers } from "redux";
import content from "./content";
// ✨ voice reducer removed - migrated to Zustand (useVoiceSelectionStore, useVoiceConfigurationStore, useVoiceFiltersStore)
// ✨ organisation reducer removed - migrated to Zustand (useGlobalStore) + React Query (useOrganisation, useOrganisationUsage)
import integration from "./integration";
import edit_content from "./edit_content";
import audio_composer from "./audio_composer";

export default combineReducers({
  content,
  // voice, // ✨ Removed - voice state migrated to Zustand + React Query
  integration,
  // organisation, // ✨ Removed - organisation state migrated to Zustand (sideBarPageType) + React Query (data & usage)
  edit_content,
  audio_composer
});